import { useQuery } from '@tanstack/react-query';
import { useAuthContext } from 'modules/auth/context';
import { getAttemptFeedback } from './api';

/** Per learner and attempt, so a second account on the same browser never sees the first one's feedback. */
export const feedbackKey = (userId: string | undefined, attemptId: string | undefined) =>
  ['feedback', 'attempt', userId, attemptId] as const;

/**
 * The learner's feedback on one attempt. Null data means none yet. No retry: a refusal
 * (someone else's attempt, for instance) is an answer, and the page must not wait on it.
 */
export function useAttemptFeedback(attemptId: string | undefined, enabled = true) {
  const { state } = useAuthContext();
  const userId = state.user?.id;
  return useQuery({
    queryKey: feedbackKey(userId, attemptId),
    queryFn: ({ signal }) => getAttemptFeedback(attemptId!, signal),
    enabled: Boolean(userId && attemptId && enabled),
    retry: false,
    staleTime: 60_000,
  });
}
